<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-chart heroicon heroicon-sm"
  >
    <path
      class="heroicon-chart-stand heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M13 37h34v4H13v-4zm35.4 21h-2.1l-5.14-16h2.1l5.15 16zM29 42h2v10h-2V42zm-12.26 0h2.1l-5.15 16h-2.1l5.15-16zM28 1h4v4h-4V1z"
    ></path>
    <polygon
      class="heroicon-chart-poster heroicon-component-fill"
      fill="#FFFFFF"
      points="47 39 60 39 60 5 1 5 1 39 13 39 13 37 47 37 47 39"
    ></polygon>
    <rect
      class="heroicon-chart-stripe heroicon-component-accent heroicon-component-fill"
      width="58"
      height="3"
      x="1"
      y="8"
      fill="#7ACFC0"
    ></rect>
    <path
      class="heroicon-shadows"
      fill="#000000"
      d="M42.13 45l-.97-3h2.1l.97 3h-2.1zM31 47v-5h-2v5h2zm-13.13-2l.97-3h-2.1l-.97 3h2.1z"
      opacity=".2"
    ></path>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M33 4h27v36H48v2h-2.63l5.14 16 .64 2H44.85l-5.79-18H33v12h-6V42h-6.06l-5.79 18H8.85l.64-2 5.14-16H12v-2H0V4h27V0h6v4zm-2-2h-2v2h2V2zM2 8h56V6H2v2zm0 1v1h56V9H2zm0 2v27h10v-2h36v2h10V11H2zm46.4 47l-5.14-16h-2.1l5.15 16h2.1zm-5.78-18H46v-2H14v2H42.62zM29 42v10h2V42h-2zm-12.26 0l-5.15 16h2.1l5.15-16h-2.1zM54 20v2h-1v-2h1zm-1 4h1v2h-1v-2zm1 4v2h-1v-2h1zm0 4v2H6V16h1v15.59l5.3-5.3.43-.43.59.2 5.53 1.84 5.6-3.73.32-.22.4.06 5.55.93 4.66-3.72.5-.4.57.29L40 22.88l3.4-1.7 3.9-3.89.2-.21.3-.06 5-1a1 1 0 1 1 .4 1.96l-4.7.94-3.8 3.79-.1.11-.15.07L42 24.12V26h-1v-1.38l-.55.27-.45.23-.45-.23-3.42-1.7-4.5 3.6-.35.27-.44-.07-5.61-.94-5.68 3.78-.4.27-.47-.15-.68-.23V30h-1v-.61l-3.73-1.25L8.41 33H17v-1h1v1h11v-1h1v1h11v-1h1v1h11v-1h1zm-12-4v2h-1v-2h1zm-13 0h1v2h-1v-2zm-4-15h11v2H24v-2h1z"
    ></path>
  </svg>
</template>
